export default __webpack_public_path__ + "static/media/Helm of the Ecliptic.7ab9792d.jpg";